import {definePerfDuration} from '../addPerfMark';

export const startupGraphqlQueryDuration = definePerfDuration({
  durationName: 'startup_graphql_query',
  startMark: 'startup_graphql_query_started',
  endMark: 'startup_graphql_query_finished',
  description:
    'GraphQL operation issued during the initial page load, from the Apollo link chain entry to its first result',
  owner: 'app_startup',
  maxPairingDurationMs: 60_000,
  devtools: {
    track: 'Startup GraphQL',
    trackGroup: 'App startup',
    color: 'secondary',
  },
});
